import { format } from 'date-fns'
import styles from './AllocationDetails.module.scss'
import { Allocation } from '@/types/vehicleAllocation'

export const AllocationDetails = ({ allocation }: { allocation: Allocation }) => {
    return (
        <div className={styles.details}>
            <div className={styles.runWrapper}>
                <span className={styles.title}>{allocation.run}</span>
            </div>

            <div className={styles.detailsContainer}>
                {allocation.additionalData.history.length > 0 && (
                    <div className={styles.statsContainer}>
                        {/* Current allocation */}
                        <div className={styles.statsRow}>
                            <span className={styles.time}>
                                {allocation.additionalData.changedAt
                                    ? format(allocation.additionalData.changedAt, 'HH:mm')
                                    : '-'}
                            </span>
                            <span>{allocation.bonnet}</span>
                        </div>

                        {/* Previous allocations */}
                        {allocation.additionalData.history.map((history) => (
                            <div key={history.time} className={styles.statsRow}>
                                <span className={styles.time}>
                                    {history.time
                                        ? history.time
                                        : history.changedAt
                                          ? format(history.changedAt, 'HH:mm')
                                          : '-'}
                                </span>
                                <span>{history.bonnet}</span>
                            </div>
                        ))}
                    </div>
                )}

                {allocation.additionalData.timeOut && (
                    <div className={styles.departureContainer}>
                        <div className={styles.time}>Departure time</div>
                        <div>{allocation.additionalData.timeOut}</div>
                    </div>
                )}

                {allocation.additionalData.remarks && (
                    <div className={styles.departureContainer}>
                        <div className={styles.time}>Notes</div>
                        <div>{allocation.additionalData.remarks}</div>
                    </div>
                )}
            </div>
        </div>
    )
}
